export default __webpack_public_path__ + "static/media/0x948d0a28b600bdbd77af4ea30e6f338167034181.8be0495a.webp";